import { render, staticRenderFns } from "./TextoAceitarTermos.vue?vue&type=template&id=a5acbe1e&"
import script from "./TextoAceitarTermos.vue?vue&type=script&lang=js&"
export * from "./TextoAceitarTermos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports